import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import NewsForm from "./NewsForm";

function NewsPage() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate("/news");
  }, [router]);

  return (
    <CrudEdit
      collectionName="news"
      id={id}
      Form={NewsForm}
      onBack={back}
    />
  );
}

export default NewsPage;
